"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Download;

var React = _interopRequireWildcard(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}
/* eslint-disable */


function Download(props) {
  var color = props.color,
      size = props.size,
      customColor = props.customColor,
      className = props.className,
      dataTest = props.dataTest,
      ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      reverseOnRtl = props.reverseOnRtl;
  return React.createElement(_Icon.default, {
    viewBox: "0 0 24 24",
    size: size,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    d: "M20.884 16.112a1.01 1.01 0 0 1 1.014 1.01v1.545A3.333 3.333 0 0 1 18.566 22H5.429A3.333 3.333 0 0 1 2.1 18.667v-1.545a1.01 1.01 0 0 1 2.02 0v1.545a1.31 1.31 0 0 0 1.308 1.308h13.138a1.31 1.31 0 0 0 1.309-1.308v-1.545c0-.558.452-1.01 1.01-1.01zM11.997 2c.892 0 1.616.723 1.616 1.615v7.554c0 .115.093.208.208.208h2.215a.808.808 0 0 1 .61 1.338l-4.039 4.646a.807.807 0 0 1-1.22 0l-4.039-4.646a.808.808 0 0 1 .61-1.338h2.215a.208.208 0 0 0 .209-.208V3.615c0-.892.723-1.615 1.615-1.615z"
  }));
}